import { Box, Button, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector, RootState } from '../../store';
import { useNavigate } from 'react-router-dom';
import {
  getAllOcspList,
  removeEventFlag,
} from '../../store/feature/satpasDevice';
import ListDataSkeleton from '../../components/template/skeleton/ListDataSkeleton';
import AddIcon from '@mui/icons-material/Add';
import LivenessDeviceSearch from '../../components/molecules/livenessDevice/LivenessDeviceSearch';
import LivenessDeviceTable from '../../components/molecules/livenessDevice/LivenessDeviceTable';
import { useGetLivenessDeviceListQuery } from '../../store/feature/service/livenessDeviceApiSlice';

const LivenessDevice = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [params, setParams] = useState<object>({});
  const [defaultValue, setDefaultValue] = useState({});
  const { isLoadingOcspConfig, isLoadingEvent, eventFlag } = useAppSelector(
    (state: RootState) => state.satpasDevice
  );

  // REGION: DISPATCH OCSP ALL
  // useEffect(()=> {
  //   dispatch(getAllOcspList(params))
  // },[params])

  const { data: dataLivenessDevice, isLoading } = useGetLivenessDeviceListQuery(params);

  // REGION: DISPATCH SUCCESS EVENT
  useEffect(() => {
    if (eventFlag) {
      dispatch(getAllOcspList(params));
      dispatch(removeEventFlag());
    }
  }, [eventFlag]);

  // REGION: RETURN TSX
  return (
    <ListDataSkeleton
      isLoading={isLoading}
      isLoadingEvent={isLoadingEvent}
      titleWidth={'300px'}
    >
      <Box>
        <Typography
          variant="h3"
          fontFamily="Open Sans"
          sx={{ marginY: '20px' }}
        >
          Liveness Check by Device
        </Typography>
        {/* <Button variant="contained" color="primary" onClick={()=> navigate('/satpas-device/create')} sx={{marginBottom: '18px'}}>
          <AddIcon /> Create
        </Button> */}
        <LivenessDeviceSearch params={params} setParams={setParams} />
        <LivenessDeviceTable
          data={dataLivenessDevice !== undefined ? dataLivenessDevice?.data?.data : []}
          params={params}
          setParams={setParams}
          defaultValue={defaultValue}
          setDefaultValue={setDefaultValue}
        />
      </Box>
    </ListDataSkeleton>
  );
};

export default LivenessDevice;
